import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";

import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@Component({
  selector: "jni-packaging-details",
  templateUrl: "./packaging-details.component.html",
  styleUrls: ["./packaging-details.component.scss"],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    ButtonModule,
    CardModule,
    InputTextModule,
  ],
})
export class PackagingDetailsComponent {
  @Input() parent!: FormGroup;
}
